var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive)?_c('div',{staticClass:"timeline-selection",style:(_vm.styles)},[_c('div',{staticClass:"timeline-selection__arrow"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }